class CardSliderCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.card-slider__track');
    this.prevButton = this.querySelector('.card-slider__arrow--prev');
    this.nextButton = this.querySelector('.card-slider__arrow--next');
    if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByCard(1));
  }

  scrollByCard(direction) {
    if (!this.track) return;
    const card = this.track.querySelector('.card-slider__card');
    if (!card) return;
    const cardWidth = card.getBoundingClientRect().width + 16;
    this.track.scrollBy({ left: cardWidth * direction, behavior: 'smooth' });
  }
}

customElements.define('card-slider-carousel', CardSliderCarousel);
